import React from "react";

const NAVY = "#1A4564";
const ACCENT = "#BEE262";
import i1 from '../../Images/i-1.png';
import i2 from '../../Images/i-2.png';
import i3 from '../../Images/i-3.png';
import i4 from '../../Images/i-4.png';
import i5 from '../../Images/i-5.png';
import i6 from '../../Images/i-6.png';
import { image } from "framer-motion/client";
const cards = [
  {
    title: "Manuelle Marketing- und Content-Erstellung frisst täglich Stunden",
    meta: "Zeitfresser",
    image: i1,
    icon: (
      <div className="relative  w-full overflow-hidden rounded-xl border border-black/5 bg-gradient-to-b from-slate-50 to-white">
     
        <img src={i1} alt="" />
      </div>
    ),
  },
  {
    title: "Leads gehen verloren, weil Anfragen & Anrufe nicht beantwortet werden",
    meta: "Verpasste Chancen",
    icon: (
      <div className="relative  w-full overflow-hidden rounded-xl border border-black/5 bg-gradient-to-b from-slate-50 to-white">
        <img src={i2} alt="" />
      </div>
    ),
  },
  {
    title: "Angebote, Rechnungen & PDFs werden händisch verarbeitet",
    meta: "Admin-Overload",
    icon: (
      <div className="relative w-full overflow-hidden rounded-xl border border-black/5 bg-gradient-to-b from-slate-50 to-white">
        <img src={i3} alt="" />
      </div>
    ),
  },
  {
    title: "Wissen steckt in Köpfen statt im System",
    meta: "Chaos",
    icon: (
      <div className="relative  w-full overflow-hidden rounded-xl border border-black/5 bg-gradient-to-b from-slate-50 to-white">
        <img src={i4} alt="" />
      </div>
    ),
  },
  {
    title: "Mitarbeiter-Onboarding kostet unnötig Zeit",
    meta: "Ramp-up",
    icon: (
      <div className="relative  w-full overflow-hidden rounded-xl border border-black/5 bg-gradient-to-b from-slate-50 to-white">
        <img src={i5} alt="" />
      </div>
    ),
  },
  {
    highlight: true,
    title: " Das Ergebnis: ",
    meta: "Impact",
    icon: (
      <div className="relative  w-full overflow-hidden rounded-xl border border-white/15 bg-gradient-to-b from-white/20 to-white/5">
        <img src={i6} alt="" />
      </div>
    ),
  },
];

export default function PainPoints() {
  return (
    <section className="w-full bg-white py-12 md:py-16">
      <div className="mx-auto w-[90%] 2xl:w-[70%]">
        <div className="rounded-[28px] border border-black/5 bg-white shadow-[0_18px_60px_rgba(15,23,42,0.08)]">
          {/* Header */}
          <div className="px-6 pt-8 md:px-10 md:pt-10">
            <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
              <div className="lg:max-w-[52%]">
                <span className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-slate-50 px-3 py-1 text-xs font-semibold text-slate-700">
                  <span
                    className="inline-flex h-5 w-5 items-center justify-center rounded-full"
                    style={{ backgroundColor: `${ACCENT}55`, color: NAVY }}
                  >
                    !
                  </span>
                  Typische Pain Points
                </span>

                <h2 className="mt-4 h2-mb h2-md h2-lg h2-2xl">
                  Warum manuelle Prozesse Ihr Unternehmen ausbremsen
                </h2>
              </div>

              
            </div>
          </div>

          {/* Cards */}
          <div className="px-6 pb-8 pt-7 md:px-10 md:pb-10">
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
              {cards.map((c, idx) => (
                <div
                  key={idx}
                  className={[
                    "rounded-2xl border p-5 transition",
                    c.highlight
                      ? " border-white/15 shadow-[0_18px_50px_rgba(15,23,42,0.18)]"
                      : "border-black/5 bg-white shadow-[0_10px_30px_rgba(15,23,42,0.06)] hover:shadow-[0_16px_40px_rgba(15,23,42,0.10)]",
                  ].join(" ")}
                  style={
                    c.highlight
                      ? {
                          background: `linear-gradient(135deg, ${NAVY} 0%, #0B2B40 55%, ${NAVY} 100%)`,
                        }
                      : undefined
                  }
                >
                  <div className="flex items-start justify-between gap-3">
                    <span
                      className={[
                        "inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold",
                        c.highlight
                          ? "border border-white/15 bg-white/10 text-white"
                          : "border border-black/10 bg-slate-50 text-slate-700",
                      ].join(" ")}
                    >
                      {c.meta}
                    </span>

                    {!c.highlight && (
                      <span
                        className="inline-flex h-8 w-8 items-center justify-center rounded-xl border border-black/10"
                        style={{ backgroundColor: `${ACCENT}55`, color: NAVY }}
                      >
                        ✓
                      </span>
                    )}
                  </div>

                  <div className="mt-4">{c.icon}</div>

                  <h3
                    className={[
                      "mt-4 font-semibold leading-snug tracking-tight",
                      c.highlight
                        ? "text-[18px] text-white md:text-[20px]"
                        : "text-[16px] text-slate-900 md:text-[17px]",
                    ].join(" ")}
                  >
                    {c.title}
                  </h3>

                  {c.highlight && (
                    <div className="mt-4 flex flex-wrap gap-2">
                      <span className="rounded-full bg-white/10 px-3 py-1 text-xs font-semibold text-white/90">
                        Hohe Kosten
                      </span>
                      <span className="rounded-full bg-white/10 px-3 py-1 text-xs font-semibold text-white/90">
                        Langsames Wachstum
                      </span>
                      <span className="rounded-full bg-white/10 px-3 py-1 text-xs font-semibold text-white/90">
                        Unnötiger Stress
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
